import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  queryKey: ['framework-agreement-files'],
  queryOptions: {},
};

const getFrameworkAgreementFiles = async (faId, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const {
    data: { data, total },
  } = await axios.get(`/api/framework_agreements/${faId}/files?${queryString}`);

  return { files: data || [], total };
};

export const useFrameworkAgreementFiles = (faId, queryParams = {}) => {
  const { queryKey, queryOptions, limit, page, ...rest } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    page,
    offset: page * limit,
    ...rest,
  };

  return useQuery([...queryKey, faId], () => getFrameworkAgreementFiles(faId, queryStringParams), {
    initialData: { files: [], total: 0 },
    ...queryOptions,
  });
};
